import type { ComponentType } from "react";

/** One group of chips in the panel (and in a phone filter sheet). */
export interface WallFilterGroup {
  key: string;
  caption: string;
  mode: "multi" | "single" | "one";
  disabled: boolean;
  options: { value: string; label: string; icon?: ComponentType<{ className?: string }>; selected: boolean }[];
  pick: (value: string) => void;
}

/**
 * The FILTERS panel behind the scrolled header's facet: every filter group as
 * chips, from the same groups and the same state as the bar, so a change here
 * is live everywhere at once. A picked chip is filled in the accent with
 * on-accent ink, the rail's own selected look.
 */
export default function WallFilterPanel({
  groups,
  canClear,
  onClearAll,
}: {
  groups: readonly WallFilterGroup[];
  /** Anything set at all; CLEAR ALL has nothing to do otherwise. */
  canClear: boolean;
  onClearAll: () => void;
}) {
  return (
    <div className="trend-filter-panel">
      <div className="trend-filter-head">
        <span className="wb-pop-caption trend-filter-title">Filters</span>
        <button type="button" className="trend-filter-clear" disabled={!canClear} onClick={onClearAll}>
          Clear all
        </button>
      </div>
      {groups.map((group) => (
        <div key={group.key} className="trend-filter-group" role="group" aria-label={group.caption}>
          <p className="trend-filter-caption" aria-hidden="true">
            {group.caption}
          </p>
          <div className="trend-filter-chips">
            {group.options.map((option) => (
              <button
                key={option.value}
                type="button"
                className="wb-rail-item"
                aria-pressed={option.selected}
                disabled={group.disabled}
                onClick={() => group.pick(option.value)}
              >
                {option.icon ? <option.icon className="shrink-0" /> : null}
                {option.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
